import { visible } from '@/directive/visible';

export const directives = {
	visible
};
